import { TranslationKey } from '@/modules/i18n/types'

export const getRoleBadgeColor = (role: string): string => {
  const roleColors = {
    'admin': 'bg-error/10 text-error border border-error/20',
    'partner': 'bg-warning/10 text-warning border border-warning/20',
    'user': 'bg-muted/10 text-muted border border-muted/20',
  }
  return roleColors[role as keyof typeof roleColors] || 'bg-muted/10 text-muted border border-muted/20'
}

export const formatRole = (role: string): string => {
  return role.charAt(0).toUpperCase() + role.slice(1)
}

export const getStatusBadgeColor = (isActive: boolean, isVerified: boolean): string => {
  if (isActive && isVerified) {
    return 'bg-success/10 text-success border border-success/20'
  } else if (isActive && !isVerified) {
    return 'bg-warning/10 text-warning border border-warning/20'
  } else {
    return 'bg-error/10 text-error border border-error/20'
  }
}

export const formatStatus = (isActive: boolean, isVerified: boolean): TranslationKey => {
  if (isActive && isVerified) {
    return 'users.activeVerified'
  } else if (isActive && !isVerified) {
    return 'users.activeUnverified'
  } else {
    return 'users.inactive'
  }
}

export const formatAccessGroups = (accessGroups: string[]): string => {
  return accessGroups.join(', ')
}

export interface Column {
  key: keyof import('@duck/api-definitions').UserService.User
  label: TranslationKey
  sortable: boolean
  visible: boolean
}

export const baseColumns: Column[] = [
  { key: 'id', label: 'common.id', sortable: true, visible: false },
  { key: 'email', label: 'common.email', sortable: true, visible: true },
  { key: 'firstName', label: 'common.firstName', sortable: true, visible: true },
  { key: 'lastName', label: 'common.lastName', sortable: true, visible: true },
  { key: 'role', label: 'common.role', sortable: true, visible: true },
  { key: 'accessGroups', label: 'common.accessGroups', sortable: false, visible: true },
  { key: 'isActive', label: 'common.isActive', sortable: true, visible: true },
  { key: 'isVerified', label: 'common.isVerified', sortable: true, visible: true },
  { key: 'invitationId', label: 'common.invitationId', sortable: true, visible: false },
  { key: 'createdAt', label: 'common.createdAt', sortable: true, visible: true },
  { key: 'updatedAt', label: 'common.updatedAt', sortable: true, visible: false },
  { key: 'lastLoginAt', label: 'common.lastLoginAt', sortable: true, visible: true },
  { key: 'notes', label: 'common.notes', sortable: false, visible: false },
  { key: 'personalInfo', label: 'personalInfo.personalInfo', sortable: false, visible: false },

]
